export const prefixReport = '/report';
